import {Constants} from './learningJournalConstants'
import { learningJournal } from '../../../model/learnJournal.model'


export function addLearningJournal(journal: learningJournal) {
	return {
		type: Constants.ADD_LEARNING_JOURNAL,
		payload: journal
	} as const
}

export function updateLearningJournal(journal: learningJournal) {
	return {
		type: Constants.UPDATE_LEARNING_JOURNAL,
		payload: journal
	} as const
}

export function deleteLearningJournal(journal: learningJournal) {
	return {
		type: Constants.DELETE_LEARNING_JOURNAL,
		payload: journal
	} as const
}